// React libraries
import * as React from 'react';
// Custom Styles
import { useStyles } from "./DraftDocumentModalStyles";
export const DraftDocumentModal = (props) => {
    const classes = useStyles(props);
    const { isModalOpen, draft, modalWidth, modalHeight } = props;
    return (React.createElement("div", { style: {
            display: isModalOpen ? "block" : "none"
        } },
        React.createElement("div", { className: classes.modal, style: { height: modalHeight, width: modalWidth } },
            React.createElement("div", { className: classes.whiteBox },
                React.createElement("p", null, draft ? "Document is saved as draft" : "Document is saved")))));
};
DraftDocumentModal.defaultProps = {
    setOpenModalState: () => { },
    draft: false
};
export default React.memo(DraftDocumentModal);
